import { http } from "../../config/HttpMethod";
import { postCommentPayload } from "../../store/model/comments/comments";
import { ESP_ENDPOINTS } from "../calculations/endpoints";

export const GetCaseComments = async (payload: string) => {
    const params = {
        caseId: payload,
    };
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_CASE_COMMENTS}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const PostCaseComment = async (payload: postCommentPayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.GET_INSERT_AND_UPDATE_COMMENTS}`, payload);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const DeleteCaseComment = async (payload: any) => {
    try {
        const response = await http.put(`${ESP_ENDPOINTS?.DELETE_COMMENT}${payload}`);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const GetChangeLog = async (payload: string) => {
    const params = {
        caseId: payload,
    };
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_CASE_CHANGE_LOG}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};
